import { atom } from "jotai";

// Atom to control the "Start over" confirmation dialog
export const startOverConfirmationAtom = atom<{
  isOpen: boolean;
  message: string;
  onConfirm: () => void;
}>({
  isOpen: false,
  message: "",
  onConfirm: () => {},
});
